import React from 'react';
import { List, Edit, Create,
     Datagrid, TextField, EditButton, 
     DisabledInput, SimpleForm, TextInput} from 'admin-on-rest';

export const GetPreferences = (props) => (
    <List {...props}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="value" />
            <EditButton />
        </Datagrid>
    </List>
);

export const CreatePreference = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="value" />
        </SimpleForm>
    </Create>
);

const PreferenceTitle = ({ record }) => {
    return <span>Edit {record ? `"${record.name}"` : ''}</span>;
};

export const EditPreference = (props) => (
    <Edit title={<PreferenceTitle />} {...props}>
        <SimpleForm>
            <DisabledInput source="id" />
            <DisabledInput source="name" />
            <TextInput source="value" />
        </SimpleForm>
    </Edit>
);


// WEBPACK FOOTER //
// ./src/preferences.js